/* eslint-disable prettier/prettier */
'use client';

import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from 'app/components/ui/form';
import { Chips } from 'primereact/chips';

export default function Tags() {
  const form = useFormContext();

  return (
    <div className=" rounded-md bg-white  dark:bg-transparent p-4">
      <h2 className="text-sm mb-2 font-semibold">Tags</h2>

      <FormField
        control={form.control}
        name="tags"
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <Chips
                value={field.value || []} // Ensure value is always an array
                onChange={e => field.onChange(e.value)} // Pass the array to onChange
                placeholder="Enter tags"
                className="w-full mt-2 bg-transparent border border-input"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
